import { MessageDescriptor } from 'react-intl';

export const Variant = {
  LOGIN_OTP: 'LOGIN_OTP',
  NOTIFICATION: 'NOTIFICATION',
} as const;

export type Variant = (typeof Variant)[keyof typeof Variant];

export const Messages = (
  optedInForUpdates: boolean
): Record<Variant, { body1: MessageDescriptor; body2: MessageDescriptor }> => ({
  [Variant.LOGIN_OTP]: {
    body1: {
      id: 'text-successful-otp-whatsapp',
      defaultMessage:
        'You have successfully opted in to receive your login OTP via Whatsapp.',
    },
    body2: {
      id: 'text-change-phone-number-via',
      defaultMessage:
        'If you would like to change your phone number, you can do so via: {br}<bold>Account Settings > Sign In & Security</bold>',
    },
  },
  [Variant.NOTIFICATION]: {
    body1: optedInForUpdates
      ? {
          id: 'text-you-have-successfully-opted',
          defaultMessage:
            'You have successfully opted in to receive important notifications and updates.',
        }
      : {
          id: 'text-youve-chosen-not-to',
          defaultMessage:
            'You’ve chosen not to receive important notifications and updates on your WhatsApp number.',
        },
    body2: {
      id: 'text-change-phone-number-via',
      defaultMessage:
        'If you would like to change your phone number, you can do so via: {br}<bold>Account Settings > Sign In & Security</bold>',
    },
  },
});
